export function formatNumber(number: number, digits = 3) {
	return Number.parseFloat(Number(number).toFixed(digits));
}
